// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from 'firebase/app';
// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyB2gTkcTlIn1gLwo6GYtomhmHC2RxZl-OE",
    authDomain: "delgado-fab-lab.firebaseapp.com",
    databaseURL: "https://delgado-fab-lab.firebaseio.com",
    projectId: "delgado-fab-lab",
    storageBucket: "delgado-fab-lab.appspot.com",
    messagingSenderId: "250230906904",
    appId: "1:250230906904:web:4bf3fcf59b02af1827e36d"
};

firebase.initializeApp( firebaseConfig );


export default firebase;
